/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { patientMiscellaneousApi } from '../api/patientMiscellaneous.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientMiscellaneous, patientMiscellaneousData } from '../../../interfaces/masters/patientMiscellaneous';

@Injectable()
export class patientmiscellaneousService extends patientMiscellaneousData {

  constructor(private api: patientMiscellaneousApi) {
    super();
  }


  list(url: string): Observable<PatientMiscellaneous[]> {
    return this.api.list(url);
  }


  create(url: string, data: PatientMiscellaneous): Observable<PatientMiscellaneous> {
    return this.api.add(url,data);
  }

  update(url: string, data: PatientMiscellaneous): Observable<PatientMiscellaneous> {
    return this.api.update(url,data);
  }



  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
